import i18next, { TOptionsBase } from 'i18next';
import { initReactI18next } from 'react-i18next';

import { toSentenceCase } from './utils/text';

i18next.use(initReactI18next).init({
  lng: 'en',
  missingKeyNoValueFallbackToKey: false,
  ns: ['core'],
  resources: {},
  returnNull: false,

  interpolation: {
    escapeValue: false,
    prefix: '[%',
    suffix: '%]',
  },
});

i18next.services.formatter?.add('sentence', (value: string) => {
  return toSentenceCase(value);
});

export const t = i18next.t;

type FormatTypes = 'sentence';

export const tFormat = (value: string, format: FormatTypes, options?: TOptionsBase) => {
  return i18next.format(options ? i18next.t(value, options) : i18next.t(value), format);
};

export default i18next;
